var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9922 28.9971C29.9922 29.5275 29.7815 30.0362 29.4064 30.4113C29.0313 30.7864 28.5226 30.9971 27.9922 30.9971H3.99219C3.46175 30.9971 2.95305 30.7864 2.57797 30.4113C2.2029 30.0362 1.99219 29.5275 1.99219 28.9971V2.99707C1.99219 2.46664 2.2029 1.95793 2.57797 1.58286C2.95305 1.20778 3.46175 0.99707 3.99219 0.99707H23.9922C24.5138 0.997123 25.0147 1.20094 25.3882 1.56507L29.3882 5.40907C29.5793 5.59538 29.7312 5.81806 29.835 6.064C29.9387 6.30994 29.9922 6.57415 29.9922 6.84107V28.9971Z",
    fill: "#EB5757",
    stroke: "#EB5757",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6537 9.44642C12.5586 8.75689 12.3279 8.09301 11.975 7.49309C11.7952 7.19492 11.5439 6.94632 11.2438 6.76984C10.9437 6.59336 10.6043 6.49456 10.2563 6.48242C9.81319 6.53014 9.39869 6.72451 9.07863 7.03467C8.75857 7.34483 8.55127 7.75301 8.48965 8.19442C8.39038 9.08725 8.62135 9.98555 9.13899 10.7198C10.7702 12.5979 12.5233 14.3666 14.387 16.0144C16.4739 17.7055 18.8352 19.0264 21.3683 19.9198C22.0623 20.2439 22.8212 20.4053 23.587 20.3918C23.9691 20.3764 24.3369 20.2423 24.6392 20.0081C24.9415 19.7739 25.1633 19.4512 25.2737 19.0851C25.3154 18.7841 25.2778 18.4774 25.1646 18.1954C25.0514 17.9133 24.8666 17.6657 24.6283 17.4771C24.1466 17.1054 23.5797 16.8597 22.979 16.7624C20.5884 16.4132 18.1483 16.6723 15.8843 17.5158C13.7217 18.1824 7.40165 20.2704 7.69232 25.5838C7.70032 25.7171 7.68299 26.5998 8.82165 26.4718C9.2901 26.3804 9.73444 26.1926 10.1265 25.9204C10.5185 25.6482 10.8497 25.2974 11.099 24.8904C12.5563 22.8331 12.7083 20.2104 12.899 17.7824C13.1802 15.0049 13.0978 12.2026 12.6537 9.44642V9.44642Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.e6d08fcb6b88b764ba6645a2a7160442.svg";
export { ForwardRef as ReactComponent };